import React from 'react';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import PhoneEnabledIcon from '@material-ui/icons/PhoneEnabled';
import MailOutlineIcon from '@material-ui/icons/MailOutline';
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord';
import { purple, green, red, blue, indigo, teal } from '@material-ui/core/colors';
import CustomButton from './CustomButton';

// スタイルを定義
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: 'flex',
      padding: theme.spacing(2),
    },
  })
);

function SubScription() {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <div className="wraper">
        <Box my={8}>
          <Typography className="font-weight-bold my-3" variant="h5" component="h2">
            ご購読について
          </Typography>
          　デーリー東北のご購読申し込みを希望の方は、下記の欄にご記入のうえ、送信して下さい。お申し込み後、お電話又はメールにてご確認させて頂きます。<br/>
          　宅配できるエリアは原則、青森県内と岩手県北です。ただし、一部地域は郵送でのお届けとなります。郵送の場合、地域によって異なりますが翌日か遠隔地は２日後以降に配達となります。<br/>
          　<span className="border-double font-weight-bold">なお､購読申し込みはフリーダイヤル、メールとも土曜、日曜、祝日等は休み明けの手配になります。ご了承下さい。</span><br/>
          　東京都（新宿、渋谷、千代田、中央、港、文京、台東の各区）の一部地域では翌日配達が可能です（ただし時間指定はできません）。<br/>
          　詳しくは株式会社全販（〒101-0003東京都千代田区一ツ橋2-6-8　トミービル3、電話03-5226-5450（代）、<a href="http://www.zempan-group.co.jp/" target="_blank">http://www.zempan-group.co.jp/</a>）まで。<br/>
        </Box>

        <Box my={8}>
          <Typography className="font-weight-bold my-3" variant="h5" component="h2">
            ご試読について
          </Typography>
          　これまでにデーリー東北を定期購読されたことのない方で、試しに読んでみたいというお客様に、７日間無料でお届けいたします。<br/>
  			  　この機会にぜひ一度デーリー東北をご覧ください。<br/>
  			  　なお､試読申し込みはフリーダイヤル、Ｅ−ｍａｉｌとも土曜、日曜、祝日等は休み明けの手配になります。ご了承下さい。
          <div class="fs90 text-danger line150 text-left m-3">
            ※試読お申込みは原則として１回限りとさせていただきます。<br/>
            ※配布エリアはデーリー東北新聞配達区域に限ります。<br/>
          </div>
        </Box>

        <Paper>
          <Box p={3} my={8}>
            <Typography className="font-weight-bold my-1" variant="subtitle1" component="h2">
              <FiberManualRecordIcon />購読料は、月ぎめ　2,900円（消費税込み）です。
            </Typography>
            <Typography className="font-weight-bold my-1" variant="subtitle1" component="h2">
              <FiberManualRecordIcon />郵送購読は、月ぎめ　4,500円（消費税込み）です。（郵送料1,600円が含まれています）
            </Typography>
            <Box m={2}>
              <PhoneEnabledIcon />フリーダイヤル<br/>
              0120-365-339<br/>
              <div class="fs90 text-danger line150 text-left">
                ※フリーダイヤルのご利用は９時３０分～１７時３０分、利用エリアは青森、岩手県に限らせて頂きます。<br/>
              </div>
            </Box>
            <Box m={2}>
              <MailOutlineIcon />メール<br/>
              <a href="mailto:hanbai@daily-tohoku.co.jp">hanbai@daily-tohoku.co.jp</a><br/>
            </Box>

            <Box my={4} textAlign="center">
              <Grid className="px-3" spacing={0} container direction="row" justify="center">
                <Grid item xs={12} md={4}>
                  <CustomButton href="http://feature.daily-tohoku.co.jp/web2/company/form/koudoku/index.php" className="px-4 m-2 d-block" size="large" themeColor={teal}>
                    ご購読申し込み
                  </CustomButton>
                </Grid>
                <Grid item xs={12} md={4}>
                  <CustomButton href="http://feature.daily-tohoku.co.jp/web2/company/form/shidoku/index.php2" className="px-4 m-2 d-block" size="large" themeColor={teal}>
                    ご試読申し込み
                  </CustomButton>
                </Grid>
              </Grid>
              <Grid className="px-3" spacing={0} container direction="row" justify="center">
                <Grid item xs={12} md={4}>
                  <CustomButton href="http://feature.daily-tohoku.co.jp/web2/company/form/addr-change/index.php" className="px-4 m-2 d-block" size="large" themeColor={red}>
                    新聞配達先住所の変更
                  </CustomButton>
                </Grid>
              </Grid>
            </Box>

          </Box>
        </Paper>

      </div>
    </div>
  );
}

export default SubScription;
